<template>
  <div
    @getBatchFile="getBatchFile"
  >
    <a-input
      id="file"
      type="file"
      accept=".txt"
      @change="batchFile"
    />
  </div>
</template>

<script>
import { getFastDFSToken, saveFileUrl } from '@/api/file'
import { axios } from '@/utils/request'
import { fn } from 'moment'
import { debug } from 'util';

export default {
  name: 'UploadBatchFile',
  data () {
    return {
      file_package: '',
      file_name: '',
      fp: '',
      fn: '',
    }
  },
  created () {
    
  },
  methods: {
    //批量上传
    batchFile() {
      //校验文件
      debugger
      var file = document.getElementById("file").files[0]
      var reader = new FileReader()
      if(typeof reader == 'undefined') {
        alert("您的浏览器暂不支持该功能", false)
        return;
      }
      var fileName = file.name
      var pointIndex = fileName.lastIndexOf(".")
      var fileSuffix = fileName.substr(pointIndex)
      if (fileSuffix == ".TXT" || fileSuffix == ".txt") {
        try {
          reader.readAsText(file, 'utf-8')
          debugger
          const _this = this
          reader.onloadend = function(f) {
            debugger
            var relArr = this.result.split(",")
            
            var uploadContent = this.result
            var file_package_temp = []
            var file_name_temp = []
            for(let i = 0; i < relArr.length; i++) {
              let temp = relArr[i].split("-")
              file_package_temp.push(temp[0])
              file_name_temp.push(temp[1])
              console.log("==" + file_package_temp[i] + "," + file_name_temp[i] + "==")
            }
            debugger
            _this.fp = file_package_temp
            _this.fn = file_name_temp
          }
        } catch (e) {
          alert("读取文件失败！", false);
          console.log(e);
        }
      } else {
        alert("您选择的文件不是CSV格式", false);
      }
    },
    
    getBatchFile() {
      debugger
      this.file_package = this.fp
      this.file_name = this.fn
    }
  }
}
</script>

<style scoped>

</style>